<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">vaccines</span>
      <p>
        Registra y gestiona el esquema de vacunación del paciente: aplica vacunas
        individuales, carga el esquema recomendado según la edad y consulta el
        historial completo en tabla.
      </p>
    </div>

    <!-- Formas de acceso -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">alt_route</span>
        Formas de acceso
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in accesos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Datos del paciente -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">person</span>
        Datos del paciente (solo lectura)
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in datosPersona" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Campos del formulario -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">edit_note</span>
        Campos del formulario
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in campos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Acciones especiales -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Tablas por edad -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">table_chart</span>
        Tabla de vacunación por edad
      </h3>
      <div class="help-estados" style="margin-bottom:0.5rem">
        <span class="help-estado-badge" style="background:#d4edda;color:#155724">0 – 5 años</span>
        <span class="help-estado-badge" style="background:#cce5ff;color:#004085">6 – 18 años</span>
        <span class="help-estado-badge" style="background:#e2d9f3;color:#4a235a">Mayor de 18 años</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem">
        El botón <strong>Tabla</strong> abre una vista específica según la edad del paciente,
        mostrando el esquema de vacunación recomendado para su grupo etario.
      </p>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Usa <strong>Recomendadas</strong> para registrar de forma automática todas las
        vacunas del esquema básico según la edad del paciente. La fecha de aplicación
        no puede ser anterior a la fecha de nacimiento ni posterior a hoy.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaVacunaPers",
  data() {
    return {
      accesos: [
        {
          icon: "medical_services",
          titulo: "Desde una atención",
          desc:   "Se accede desde el botón 'Vacunas' en el panel lateral del formulario de atención. El breadcrumb muestra la atención de origen.",
        },
        {
          icon: "person",
          titulo: "Desde el perfil del paciente",
          desc:   "Se accede desde el formulario de la persona. El breadcrumb muestra el nombre completo del paciente.",
        },
      ],
      datosPersona: [
        {
          icon: "badge",
          titulo: "Nombre y documento",
          desc:   "Nombre completo y número de identificación del paciente. No son editables desde esta pantalla.",
        },
        {
          icon: "expand_more",
          titulo: "Más información",
          desc:   "Despliega datos adicionales: email, estado civil, localidad, teléfono, nombres, apellidos, fecha de nacimiento, sexo, dirección e IDs de auditoría.",
        },
      ],
      campos: [
        {
          icon: "vaccines",
          titulo: "Vacuna",
          desc:   "Selecciona el tipo de vacuna del catálogo. Al seleccionarla se cargan automáticamente los productos disponibles para esa vacuna.",
        },
        {
          icon: "medication",
          titulo: "Vacuna producto",
          desc:   "Marca o presentación comercial de la vacuna aplicada. Se filtra automáticamente según la vacuna seleccionada.",
        },
        {
          icon: "calendar_today",
          titulo: "Fecha de aplicación",
          desc:   "Fecha en que se administró la vacuna. No puede ser anterior a la fecha de nacimiento del paciente ni posterior a la fecha actual.",
        },
        {
          icon: "text_snippet",
          titulo: "Observación",
          desc:   "Notas clínicas adicionales sobre la aplicación: reacciones, sitio de aplicación u otra información relevante. Campo obligatorio.",
        },
        {
          icon: "pin",
          titulo: "Lote",
          desc:   "Número de lote del vial utilizado, necesario para trazabilidad y farmacovigilancia. Campo obligatorio.",
        },
      ],
      acciones: [
        {
          icon:   "add_circle",
          color:  "#0059cc",
          titulo: "Nueva vacuna",
          desc:   "Abre el formulario para registrar manualmente la aplicación de una vacuna al paciente.",
        },
        {
          icon:   "edit",
          color:  "#198754",
          titulo: "Editar",
          desc:   "Abre el formulario con los datos del registro seleccionado para corregir o completar la información.",
        },
        {
          icon:   "vaccines",
          color:  "#0059cc",
          titulo: "Recomendadas",
          desc:   "Registra automáticamente todas las vacunas del esquema básico recomendado para la edad del paciente. Solo agrega las que aún no están en el historial.",
        },
        {
          icon:   "table_chart",
          color:  "#198754",
          titulo: "Tabla",
          desc:   "Abre la tabla de vacunación correspondiente al grupo etario del paciente (0–5, 6–18 o mayor de 18 años) para una vista visual del esquema.",
        },
        {
          icon:   "filter_list",
          color:  "#6f42c1",
          titulo: "Filtro por vacuna",
          desc:   "Permite filtrar la tabla para mostrar solo los registros de una vacuna específica. Selecciona 'Todas' para ver el historial completo.",
        },
        {
          icon:   "refresh",
          color:  "#6c757d",
          titulo: "Todos los registros",
          desc:   "Recarga la lista completa de vacunas registradas para el paciente.",
        },
        {
          icon:   "download",
          color:  "#fd7e14",
          titulo: "Exportar Excel",
          desc:   "Descarga el historial de vacunación en formato Excel para su archivo o análisis externo.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>